import { useFormikContext } from 'formik';

import { Button, ButtonsGrid } from 'components/common/button/button';
import useIsSuccessAndError from 'lib/hooks/use-is-success-and-error';

import { FormButtonsProps, FormValues } from 'types';
import { VIEWS } from 'lib/constants';
import { isValidAmount } from 'utils';

const Buttons = ({
  loading,
  step,
  isLastStep,
  onClickBackHandler
}: FormButtonsProps) => {
  const formik = useFormikContext<FormValues>();
  const { isLoading, isError } = useIsSuccessAndError();

  const isDisabled = () => {
    if (loading) {
      return true;
    } else {
      if (step === VIEWS.ENTER_RECEIVER) {
        if (isLoading || isError) {
          return true;
        }
      } else {
        if (!(isValidAmount(formik.values.amount) && formik.isValid)) {
          return true;
        }
      }
    }
    return false;
  };

  return (
    <ButtonsGrid gridGap="20px">
      <Button type="submit" disabled={isDisabled()} loading={loading} fullwidth>
        {loading ? (
          'Sending'
        ) : (
          <>{isLastStep ? 'Confirm & Send' : 'Continue'}</>
        )}
      </Button>
      {step !== VIEWS.ENTER_AMOUNT && (
        <Button
          type="button"
          onClick={onClickBackHandler}
          fullwidth
          variant="secondary"
        >
          Cancel
        </Button>
      )}
    </ButtonsGrid>
  );
};

export default Buttons;
